import DNArticleSaga from "./saga";
import DNArticleTableReducer from "./reducers/DNArticleTableReducer";
import AsyncComponent from "ui/AsyncComponent";
import store from "rootStore";
import { permissionsType, routingType } from "types/configTypes";
import IConfig from "interfaces/IConfig";

export const url = "articles";

const getConfig = (permissions: permissionsType, parentUrl: string) => {
    const config: IConfig = {
        active: false,
        routing: [],
        url,
    };

    let routing: routingType = [];

    if (permissions["dn.articles.read"]) {
        config.active = true;

        store.reducerManager?.add("DnArticleTable", DNArticleTableReducer);
        store.injectSaga?.("DnArticleSaga", DNArticleSaga);

        routing.push({
            path: url,
            element: (
                <AsyncComponent path="DN/Articles/pages/DNArticleIndexPage" />
            ),
        });
    }

    if (routing.length > 0) {
        config.routing = routing.map((item) => parentUrl + "/" + item.path);
    }

    return { config, routing };
};

export default getConfig;
